import /* webpackPreload: true */ /* webpackChunkName: "maintenance_cogs" */ maintenanceCogs
    from 'assets/images/maintenance-cogs.svg?url';

const demoImages = { maintenanceCogs };


export default demoImages;
